import { Controller } from '@hotwired/stimulus';

// Live password strength meter (score 0..4) shown as 4 bars + a label.
//
// Usage:
//   <input data-action="password-strength#update" ...>
//   <div data-controller="password-strength" hidden data-password-strength-target="wrap">
//     <div class="strength__bars">
//       <span data-password-strength-target="bar"></span> x4
//     </div>
//     <span class="strength__label" data-password-strength-target="label"></span>
//   </div>
const LABELS = ['', 'Faible', 'Correct', 'Bon', 'Robuste'];
const COLORS = [
  'transparent',
  'var(--color-danger)',
  'var(--color-warning)',
  'var(--color-indigo-400)',
  'var(--color-success)',
];

export default class extends Controller {
  static targets = ['wrap', 'bar', 'label'];

  update({ target }) {
    const score = this.score(target.value);
    this.wrapTarget.hidden = target.value.length === 0;

    this.barTargets.forEach((bar, i) => {
      bar.style.background = i < score ? COLORS[score] : 'var(--color-slate-200)';
    });
    this.labelTarget.textContent = LABELS[score];
    this.labelTarget.style.color = COLORS[score];
  }

  score(pw) {
    if (!pw) return 0;
    let s = 0;
    if (pw.length >= 8) s += 1;
    if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s += 1;
    if (/\d/.test(pw)) s += 1;
    if (/[^A-Za-z0-9]/.test(pw)) s += 1;
    return s;
  }
}
